/**
 * Reduces a BCP-47 locale tag down to its lowercased primary subtag.
 *
 * `'cs-CZ'` -> `'cs'`, `'en'` -> `'en'`, `null`/`undefined`/`''` -> `''`.
 *
 * Callers that need a different empty fallback (e.g. `'en'` for
 * `Intl.DisplayNames`) should apply it with `|| 'en'` at the call site.
 */
export function getPrimaryLanguageSubtag(
  locale: string | null | undefined,
): string {
  return (locale ?? '').toLowerCase().split('-')[0];
}
